<template>
  <div class="">
    <h3>课程激活码</h3>
    <a-form-model
      class="active-form"
      ref="activationForm"
      :rules="rules"
      :model="form"
      :label-col="{ span: 3 }"
      :wrapper-col="{ span: 15 }"
    >
      <a-form-model-item
        label="激活码"
        prop="code"
      >
        <div class="active-layout">
          <a-input
            class="active-input"
            placeholder="请输入激活码"
            type="text"
            v-model="form.code"
          />
          <a-button
            class="active-button"
            type="primary"
            @click="activation('activationForm')"
            :loading="loading"
          >激活
          </a-button>
        </div>
      </a-form-model-item>
      <!-- <a-form-model-item :wrapper-col="{ offset: 3 }">
      </a-form-model-item> -->
    </a-form-model>
    <z-modal
      class="active-model"
      :titleBorder="true"
      :border="false"
      :loading="loading"
      @close="activeClose"
      :visible="visible"
      title="激活课程码"
      type="double"
      @submit="activationPack"
    >
      <div class="main">
        <div class="main_left">
          <p
            :class="{ 'title--active': tabActiveIndex == index }"
            v-for="(item, index) in list"
            :key="index"
            @click="tabClick(index)"
          >
            {{ item.typeName }}
          </p>
        </div>
        <div class="main_right">
          <div
            v-if="list[tabActiveIndex] && list[tabActiveIndex].typeName"
            class="current-choosed"
          >
            <div>{{ list[tabActiveIndex].typeName || '' }}</div>
            <div
              class="select-all"
              @click="selectAll(!isSelectedAll)"
            >{{ isSelectedAll ? '取消全选' : '全选' }}</div>
          </div>
          <p
            :class="{ 'describe--active': cacheChooseDataList.indexOf(item.suitId) > -1 }"
            v-for="(item, index) in dataList"
            :key="index"
            @click="selectLesson(item.suitId)"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
    </z-modal>
    <z-modal
      @submit="$router.push({ name: 'course' })"
      width="492px"
      buttonText="立即跳转"
      cancelText="返回"
      count
      :visible.sync="successVisible"
      type="double"
      @close="close"
      :border="false"
    >
      <div class="info">
        <a-icon
          class="icon"
          type="check-circle"
          theme="filled"
        />
        <h4>激活成功</h4>
        <p>将为您自动跳转我的课程</p>
      </div>
    </z-modal>
  </div>
</template>
<script>
import zModal from '@/components/ZModal'
import { activationCode, feachObsO } from '@/api/system'
import Vue from 'vue'
export default {
  name: '',
  data () {
    return {
      visible: false,
      successVisible: false,
      form: {
        code: '',
        suitId: ''
      },
      rules: {
        code: [{ required: true, message: '请输入激活码', trigger: ['blur', 'change'] }]
      },
      list: [],
      dataList: [],
      cacheChooseDataList: [],
      tabActiveIndex: 0,
      loading: false
    }
  },
  watch: {
    tabActiveIndex (val) {
      this.dataList = this.list[val].list
    },
    visible (val) {
      if (!val) {
        this.form.suitId = ''
      }
    }
  },
  computed: {
    isSelectedAll () {
      return this.dataList.length === this.cacheChooseDataList.length
    }
  },
  components: {
    zModal
  },
  created () {
    // this.$http({
    //   url: 'http://static.kuaijisishu.cn/data/courseType/00f9fb0932a5198d883526f3a370dd5d.o',
    //   method: 'get',
    // }).then(res => {
    //   this.list = res
    //   this.dataList = res[this.tabActiveIndex].list
    //   this.visible = true
    // })
  },
  methods: {
    activeClose () {
      this.visible = false
      this.form.suitId = ''
    },
    close () { },
    tabClick (index) {
      this.tabActiveIndex = index
      this.cacheChooseDataList = []
    },
    activationPack () {
      // todo 全选为批量，接口逻辑待修改
      if (!this.cacheChooseDataList.length) {
        this.$message.error('请选择课程')
        return
      }
      // if (!this.form.suitId) {
      //   this.$message.error('请选择课程')
      //   return
      // }
      this.form.suitId = this.cacheChooseDataList[0]
      this.activationCodeAsync(this.form)
    },
    activation (fromName) {
      this.$refs[fromName].validate(async valid => {
        if (valid) {
          if (this.form.code.replace(/\s*/g, '').length === 0) {
            this.$message.error('请填写正确激活码')
            return
          }
          this.activationCodeAsync(this.form)
        }
      })
    },
    async activationCodeAsync (code) {
      try {
        this.loading = true
        const res = await activationCode({ ...code, code: this.form.code.replace(/\s*/g, '') })
        if (res.status) {
          this.visible && (this.visible = false)
          const userInfo = Vue.ls.get('USER_INFO')
          userInfo.isAudition = false
          Vue.ls.set('USER_INFO', userInfo)
          this.successVisible = true
          this.form.code = ''
          // this.form.suitId = ''
        } else {
          const data = await feachObsO(res.url)
          if (data.length) {
            this.visible = true
            this.list = data
            this.dataList = data[0].list
          }
        }
      } catch (error) {
        console.log(error)
        this.visible = false
      } finally {
        this.loading = false
      }
    },
    /**
     * @description 课程激活码选择
     * @param { String | Number} suitId id
     */
    selectLesson (suitId) {
      const hasId = this.cacheChooseDataList.indexOf(suitId)
      if (hasId === -1) {
        this.cacheChooseDataList.push(suitId)
        return
      }
      this.cacheChooseDataList.splice(hasId, 1)
    },
    /**
     * 全选课程激活码
     * @param { Boolean } status 全选状态
     */
    selectAll (status) {
      status ? (this.cacheChooseDataList = this.dataList.map(v => v.suitId)) : (this.cacheChooseDataList = [])
    }
  }
}
</script>
<style lang="less" scoped>
.active-form {
  .active-layout {
    display: flex;
    align-items: center;
    .active-input {
      width: 260px;
      height: 44px;
      margin-right: 18px;
      background-color: #f5f7fa;
      border: 1px solid transparent;
    }
    .active-button {
      padding: 6px 24px;
      font-size: 14px;
      height: auto;
    }
  }
  /deep/ .ant-form-item {
    height: 44px;
    .ant-form-item-label {
      height: 100%;
      line-height: 44px;
      font-weight: 600;
    }
  }
}
.active-model {
  /deep/ .ant-modal-content {
    border-radius: 4px;
    width: 632px;
  }
  /deep/ .modal_footer {
    .btns {
      box-sizing: border-box;
      padding: 0 160px;
    }
    .ant-btn {
      width: 102px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 14px;
    }
    .btn_left {
      color: #303133;
      border: 1px solid #84878d;
    }
  }
}
h3 {
  padding-bottom: 15px;
  margin-bottom: 32px;
  color: #181d21;
  font-weight: bold;
  font-size: 16px;
  border-bottom: 1px solid #d6dae3;
}

.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  .icon {
    font-size: 52px;
    color: #1564ff;
  }
  h4 {
    margin: 14px 0;
    font-size: 17px;
    color: #181d21;
  }
  p {
    margin-bottom: 12px;
    font-size: 15px;
    color: #5e668d;
  }
}
.main {
  display: flex;
  margin: 0 -20px 14px -20px;
  font-size: 16px;
  max-height: 354px;
  .main_left {
    width: 208px;
    text-align: center;
    background: #f5f7fa;
    color: #303133;
    overflow-y: auto;
    font-size: 14px;
  }
  .main_right {
    // width: 100%;
    flex: 1;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: block;
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: rgba(0, 0, 0, 0.48);
    }
    p {
      font-size: 14px;
      padding-left: 24px;
      width: 100%;
      transition: all 0.2s;
    }
    .select-all {
      font-size: 12px;
      font-weight: 400;
      color: #4b7dfd;
      cursor: pointer;
    }
    .current-choosed {
      box-sizing: border-box;
      // height: 22px;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      display: flex;
      align-items: center;
      padding: 14px 18px 14px 26px;
      position: sticky;
      width: 100%;
      top: 0;
      right: 0;
      background-color: #fff;
      justify-content: space-between;
    }
  }
  .title--active {
    color: #000000;
    background-color: #fff;
  }
  .describe--active {
    color: #1564ff;
    background: #f2f6ff;
  }
  p {
    height: 45px;
    line-height: 45px;
    cursor: pointer;
  }
}

.ant-btn {
  background-color: #1564ff;
}
/deep/.ant-form-item-required {
  &::before {
    content: '';
  }
  &::after {
    content: '';
    margin-right: 22px;
  }
}
</style>
